import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, Search, Plus, MessageSquare, Map } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const ITEMS = [
  { id: "home", label: "Krye", icon: Home, route: "/" },
  { id: "search", label: "Kërko", icon: Search, route: "/kerko" },
  { id: "post", label: "Publiko", icon: Plus, route: "/publiko", prominent: true },
  { id: "messages", label: "Mesazhe", icon: MessageSquare, route: "/mesazhe", auth: true },
  { id: "map", label: "Harta", icon: Map, route: "/harta" },
];

export function BottomNav() {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const { user, setAuthOpen, badges } = useAuth();

  const isPrivate = user && user !== false && user.account_type === "private";
  const items = ITEMS.filter((it) => !(it.id === "post" && isPrivate));

  const go = (item) => {
    if (item.auth && !(user && user !== false)) { setAuthOpen(true); return; }
    nav(item.route);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-lg border-t border-slate-200/80 px-2 pt-1.5 pb-2 safe-bottom flex items-end justify-around md:max-w-lg md:mx-auto md:rounded-t-3xl md:shadow-2xl">
      {items.map((item) => {
        const active = pathname === item.route || (item.route !== "/" && pathname.startsWith(item.route));
        const Icon = item.icon;
        if (item.prominent) {
          return (
            <button key={item.id} data-testid="bottom-nav-post" onClick={() => go(item)} className="flex flex-col items-center -mt-6">
              <span className="bg-emerald-500 hover:bg-emerald-600 active:scale-95 transition-all text-white rounded-full p-3.5 shadow-lg shadow-emerald-500/40 ring-4 ring-white">
                <Icon className="w-6 h-6" strokeWidth={2.5} />
              </span>
              <span className="text-[11px] font-semibold text-emerald-600 mt-0.5">{item.label}</span>
            </button>
          );
        }
        return (
          <button key={item.id} data-testid={`bottom-nav-${item.id}`} onClick={() => go(item)} className="relative flex flex-col items-center gap-0.5 px-2 py-1 min-w-[56px]">
            {item.id === "messages" && (badges?.messages || 0) > 0 && (
              <span data-testid="nav-messages-badge" className="absolute top-0 right-2 min-w-[16px] h-4 px-1 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center">{badges.messages}</span>
            )}
            <Icon className={`w-[22px] h-[22px] ${active ? "text-emerald-600" : "text-slate-400"}`} strokeWidth={active ? 2.5 : 2} />
            <span className={`text-[11px] ${active ? "font-bold text-emerald-600" : "font-medium text-slate-400"}`}>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}

export default BottomNav;
